import React, { useEffect, useState } from "react";
import { apiCall } from "../main/ApiCall";
import { useNavigate, useParams } from "react-router-dom";
import "../css/others/ProjectHistory.css";
import "../css/others/Table.css";
import { ProjectHistoryEntry } from '../interFaces/interfaces';
const ProjectHistory: React.FC = () => {
  const [history, setHistory] = useState<ProjectHistoryEntry[]>([]);
  const [, setLoading] = useState<boolean>(true);
  const [expandedVersions, setExpandedVersions] = useState<Record<string, boolean>>({});
  const { projectId } = useParams<{ projectId: string }>();
  const navigate = useNavigate();
  const clientId = localStorage.getItem("clientId");
  const formatFieldName = (fieldName: string): string => {
    const result = fieldName.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  };
  useEffect(() => {
    const fetchHistory = async () => {
      if (!projectId) return;
      try {
        const response = await apiCall("get", `/api/projects/history?projectId=${projectId}&clientId=${clientId}`);
        const responseData = response.data?.data || response.data || response;
        if (Array.isArray(responseData)) {
          const expanded = responseData.reduce((acc, entry) => {
            acc[entry.id] = true;
            return acc;
          }, {} as Record<string, boolean>);
          setExpandedVersions(expanded);
          setHistory(responseData);
        } else {
          console.error("Unexpected response format:", responseData);
        }
      } catch (err) {
        console.error("Error fetching project history:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, [projectId, clientId]);
  const toggleVersion = (id: string) => {
    setExpandedVersions(prev => ({ ...prev, [id]: !prev[id] }));
  };
  const hasChanges = history.some((entry) => entry.fieldChanges && Object.keys(entry.fieldChanges).length > 0);
  const handleGoBack = () => {
    navigate(-1);
  }
  return (
    <div className="history-container">
      <div className="history-header">
        <h2>Project History - {projectId}</h2>
      </div>
      {!hasChanges ? (
        <div className="spinner">No changes found.</div>
      ) : (
        <div className="versions-list">
          {history.map((entry, index) => {
            if (!entry.fieldChanges || Object.keys(entry.fieldChanges).length === 0) {
              return null;
            }
            const versionNumber = history.length - index;
            const isExpanded = expandedVersions[entry.id];
            return (
              <div key={entry.id} className={`version-card ${isExpanded ? 'expanded' : ''}`}>
                <div className="version-header" onClick={() => toggleVersion(entry.id)}>
                  <div className="version-title">
                    <span className="version-badge">Version {versionNumber}</span>
                    {entry.updatedDate && (
                      <span className="version-date">
                        {new Date(entry.updatedDate).toLocaleString()}
                      </span>
                    )}
                  </div>
                  <div className="version-toggle">{isExpanded ? '▼' : '▶'}</div>
                </div>
                {isExpanded && (
                  <div className="version-changes">
                    <table className="changes-table">
                      <thead>
                        <tr>
                          <th>Field</th><th>Previous Value</th><th>New Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.entries(entry.fieldChanges).map(([field, value]) => {
                          if (!value) return null;
                          const [oldValue, newValue] = value.toString().split(" -> ");
                          const displayFieldName = formatFieldName(field);
                          return (
                            <tr key={`${entry.id}-${field}`} className="change-row">
                              <td className="field-name">{displayFieldName}</td>
                              <td className="old-value">{oldValue || "N/A"}</td>
                              <td className="new-value">{newValue || "N/A"}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <div className="change-summary">
                      {Object.keys(entry.fieldChanges).length} changes made in this version
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      <button className="back-button2" onClick={handleGoBack}>Back</button>
    </div>
  );
};
export default ProjectHistory;